/**
=========================================================
* Material Dashboard 2 PRO React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from '@mui/material/Card'
import Grid from '@mui/material/Grid'

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import MDButton from 'components/MDButton'
import MDInput from 'components/MDInput'
import { useAppServices } from 'hook/services'
import { useParams } from 'react-router-dom'
import { useState } from 'react'

function SupportDetail({ data, handleChange }) {
  const Service = useAppServices()
  const { id } = useParams()
  const [errors, setErrors] = useState({
    support_email: '',
    support_phone: '',
    documentation_url: '',
    support_website_url: ''
  })

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return re.test(email)
  }

  const validatePhone = (phone) => {
    const re = /^(\+?\d{1,3}[- ]?)?\(?\d{3}\)?[- ]?\d{3}[- ]?\d{4}$/
    return re.test(phone)
  }

  const validateUrl = (url) => {
    if (!url) return true
    try {
      const urlObj = new URL(url)
      return urlObj.protocol === 'https:'
    } catch {
      return false
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    const formData = new FormData(e.target)
    const payload = {
      support_email: formData.get('support_email'),
      documentation_url: formData.get('documentation_url'),
      support_website_url: formData.get('support_website_url'),
      support_phone: formData.get('support_phone'),
      _id: id,
    }
    console.log("payloadTest", payload)

    const newErrors = {
      support_email: '',
      support_phone: '',
      documentation_url: '',
      support_website_url: ''
    }

    let isValid = true
    if (!payload.support_email) {
      newErrors.support_email = 'Email is required'
      isValid = false
    } else if (!validateEmail(payload.support_email)) {
      newErrors.support_email = 'Please enter a valid email address'
      isValid = false
    }
    if (!payload.support_phone) {
      newErrors.support_phone = 'Phone number is required'
      isValid = false
    } else if (!validatePhone(payload.support_phone)) {
      newErrors.support_phone = 'Please enter a valid phone number (e.g., +1 234 567 8900)'
      isValid = false
    }
    if (payload.documentation_url && !validateUrl(payload.documentation_url)) {
      newErrors.documentation_url = 'URL must start with https://'
      isValid = false
    }

    if (payload.support_website_url && !validateUrl(payload.support_website_url)) {
      newErrors.support_website_url = 'URL must start with https://'
      isValid = false
    }

    setErrors(newErrors)

    if (!isValid) return

    const { response } = await Service.snapshot_onboarding.update({ payload })
    console.log("ResponseTest", response)
    if (response) {
      handleChange()
    }
  }

  const formatUrl = (url) => {
    if (!url) return ''
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      return `https://${url}`
    }
    return url
  }

  return (
    <Card id="support-details" key={data?._id}>
      <MDBox p={3}>
        <MDTypography variant="h5">Support Detail</MDTypography>
      </MDBox>
      <MDBox component="form" onSubmit={handleSubmit} role="form" pb={3} px={3}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <MDTypography variant="button" display="block" gutterBottom>
              Support Email *
            </MDTypography>
            <MDInput
              fullWidth
              required
              label="Support Email"
              name="support_email"
              defaultValue={data?.support_email}
              error={!!errors.support_email}
              helperText={errors.support_email}
            />
          </Grid>
          <Grid item xs={12}>
            <MDTypography variant="button" display="block" gutterBottom>
              Documentation URL
            </MDTypography>
            <MDInput
              fullWidth
              label="Documentation URL (must be HTTPS)"
              name="documentation_url"
              defaultValue={formatUrl(data?.documentation_url)}
              error={!!errors.documentation_url}
              helperText={errors.documentation_url}
            />
          </Grid>
          <Grid item xs={12}>
            <MDTypography variant="button" display="block" gutterBottom>
              Support Website URL
            </MDTypography>
            <MDInput
              fullWidth
              label="Support Website URL (must be HTTPS)"
              name="support_website_url"
              defaultValue={formatUrl(data?.support_website_url)}
              error={!!errors.support_website_url}
              helperText={errors.support_website_url}
            />
          </Grid>
          <Grid item xs={12}>
            <MDTypography variant="button" display="block" gutterBottom>
              Support Phone Number *
            </MDTypography>
            <MDInput
              fullWidth
              required
              label="Support Phone Number (e.g., +1 234 567 8900)"
              name="support_phone"
              defaultValue={data?.support_phone}
              error={!!errors.support_phone}
              helperText={errors.support_phone}
            />
          </Grid>
        </Grid>
        <MDBox
          display="flex"
          justifyContent="space-between"
          alignItems="flex-end"
          flexWrap="wrap"
          mt={3}
        >
          <MDBox ml="auto">
            <MDButton variant="gradient" color="dark" size="small" type="submit">
              update
            </MDButton>
          </MDBox>
        </MDBox>
      </MDBox>
    </Card>
  )
}

export default SupportDetail